import styled from 'styled-components'
import { ReactComponent as ArrowIcon } from 'libs/shared/assets/src/lib/icons/arrows/arrowRight.svg'
import { ReactComponent as MinusIcon } from 'libs/shared/assets/src/lib/icons/minusIcon.svg'
import { ReactComponent as PlusIcon } from 'libs/shared/assets/src/lib/icons/plusIcon.svg'
import { ReactComponent as CheckIcon } from 'libs/shared/assets/src/lib/icons/check.svg'

export interface StyledActiveProps {
  isActive?: boolean;
}

export const StyledCheckIcon = styled(CheckIcon)<StyledActiveProps>(({
  theme: { palette }, isActive,
}) => `
  > path {
      fill: ${isActive ? palette.product.location.main : palette.dark.medium};
      stroke: ${isActive ? palette.product.location.main : palette.dark.medium};
      }
`)

export const StyledDownArrowIcon = styled(ArrowIcon)<StyledActiveProps>(({
  theme: { palette }, isActive,
}) => `
  transform: rotate(90deg);
  > path {
      stroke: ${isActive ? palette.product.location.main : palette.dark.medium};
      }
`)

export const StyledUpArrowIcon = styled(ArrowIcon)<StyledActiveProps>(({
  theme: { palette }, isActive,
}) => `
  transform: rotate(-90deg);
  > path {
        stroke: ${isActive ? palette.product.location.main : palette.dark.medium};
      }
`)

export const StyledPlusIcon = styled(PlusIcon)<StyledActiveProps>(({
  theme: { palette }, isActive,
}) => `
  > path {
        fill: ${isActive ? palette.product.location.main : palette.dark.medium};
        stroke: ${isActive ? palette.product.location.main : palette.dark.medium};
      }
`)

export const StyledMinusIcon = styled(MinusIcon)<StyledActiveProps>(({
  theme: { palette }, isActive,
}) => `
  > path {
    fill: ${isActive ? palette.product.location.main : palette.dark.medium};
    stroke: ${isActive ? palette.product.location.main : palette.dark.medium};
  }
`)
